import { Injectable } from '@angular/core';
import { CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { UserService } from '@app/services/user.service'
import { Router } from '@angular/router';
import { ConstantsService } from '@app/services/constants.service'
import { role_name } from '../config/role-name.enum';
import { path_module_public } from '@app/models/routes.name';

@Injectable({
  providedIn: 'root'
})
export class AuthGuard implements CanActivate {

  constructor(
    private userService: UserService,
    private router: Router,
    private constantsService: ConstantsService,
  ) { }

  canActivate(activatedRouteSnapshot: ActivatedRouteSnapshot, routerStateSnapshot: RouterStateSnapshot): boolean {

    if (activatedRouteSnapshot.data.checkActiveLoginOrRole && activatedRouteSnapshot.data.checkActiveLoginOrRole === true) {

      if (!this.userService.loggedIn()) {
        return true;
      }

      if (activatedRouteSnapshot.data.roles && activatedRouteSnapshot.data.roles.indexOf(this.userService.getUserProfile()) > -1) {
        return true;
      }
      this.router.navigate([path_module_public.forbbiden]);
      return false;
    }

    if (activatedRouteSnapshot.data.checkActiveLoginAndRole && activatedRouteSnapshot.data.checkActiveLoginAndRole === true) {

      if (this.userService.loggedIn() && activatedRouteSnapshot.data.roles && activatedRouteSnapshot.data.roles.indexOf(this.userService.getUserProfile()) > -1) {
        return true;
      }
      this.router.navigate([path_module_public.forbbiden]);
      return false;
    }

    if (activatedRouteSnapshot.data.checkActiveLogin && activatedRouteSnapshot.data.checkActiveLogin === true) {

      if (this.userService.loggedIn()) {

        if (this.userService.isEmployee()) {

          const returnUrl = activatedRouteSnapshot.queryParams?.returnUrl || this.constantsService.BASE_PATH_HOME_EMPLOYEE;

          this.router.navigate([returnUrl]);
          return false;
        }
        else if (this.userService.isEmployer()) {
          this.router.navigate([this.constantsService.BASE_PATH_HOME_EMPLOYER]);
          return false;
        }
      }
      return true;

    }

    if (this.userService.loggedIn()) {

      // check if route is restricted by role
      if (activatedRouteSnapshot.data.roles && activatedRouteSnapshot.data.roles.indexOf(this.userService.getUserProfile()) === -1) {
        // role not authorised so redirect to home page
        this.router.navigate([path_module_public.forbbiden]);
        return false;
      }
      return true;
    }

    if (activatedRouteSnapshot.data.roles && activatedRouteSnapshot.data.roles.indexOf(role_name.Employer) > -1) {
      this.router.navigate([this.constantsService.BASE_PATH_LOGIN_EMPLOYER], { queryParams: { returnUrl: routerStateSnapshot.url } });
      return false;
    }

    if (activatedRouteSnapshot.data.roles && activatedRouteSnapshot.data.roles.indexOf(role_name.Employee) > -1) {
      this.router.navigate([this.constantsService.BASE_PATH_LOGIN_EMPLOYEE], { queryParams: { returnUrl: routerStateSnapshot.url } });
      return false;
    }

    if (activatedRouteSnapshot.data.roles && activatedRouteSnapshot.data.roles.indexOf(role_name.Admin) > -1) {
      this.router.navigate([this.constantsService.BASE_PATH_LOGIN_ADMIN], { queryParams: { returnUrl: routerStateSnapshot.url } });
      return false;
    }

    return true;
  }
}
